<template>
  <div class="container">
    <div @click="goToAbout()" class="main-container mh-60 h-shadow-m shadow-s h-m-button">
      <ReadAboutIcon class="hover-scale icon" />

      <span class="link">{{ $t('shared.readAboutTile.aboutCAnnect') }}</span>
    </div>
    <div @click="goToConditions()" class="main-container h-shadow-m shadow-s h-m-button">
      <TermsIcon class="hover-scale icon" />
      <span class="link">{{ $t('shared.readAboutTile.conditions') }}</span>
    </div>
  </div>
</template>

<script>
import TermsIcon from 'vue-material-design-icons/BookOpenVariant.vue'
import ReadAboutIcon from 'vue-material-design-icons/InformationOutline.vue'
export default {
  name: 'ReadAboutTile',
  components: { TermsIcon, ReadAboutIcon },
  methods: {
    goToAbout() {
      this.$router.push({ name: 'about' })
    },
    goToConditions() {
      this.$router.push({ name: 'agreement' })
    }
  }
}
</script>

<style scoped lang="scss">
.link {
  justify-content: center
}
.container {
  @media (max-width: $header-change) {
    width: 100%;
  }
}

.main-container {
  margin: 0 0 1rem 0;
  max-width: 220px;
  background-color: white;
  background-color: rgba(255,255,255,0.4);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0 10px 0;

  @media (max-width: $header-change) {
    max-width: none;
    width: 100%;
  }
  .icon {
    margin-left: 15px;
    display: flex;
    align-items: center;
    color: #953D51;
  }
}
</style>
